import React from "react";
import { useNavigate } from "react-router-dom";
import "./Deleteaccount.css";

const Deleteaccount = () => {
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate("/overview");
  };

  return (
    <div className="delete-container">
      <p className="delete-question">You want to delete your account?</p>
      <div className="delete-buttons">
        <button className="delete-btn delete-yes" disabled>
          Yes
        </button>
        <button className="delete-btn delete-cancel" onClick={handleCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default Deleteaccount;
